"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
exports.DocumentCardLocationGlobalClassNames = {
    root: 'ms-DocumentCardLocation'
};
exports.getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var palette = theme.palette;
    var classNames = Styling_1.getGlobalClassNames(exports.DocumentCardLocationGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                fontSize: Styling_1.FontSizes.small,
                color: palette.neutralPrimary,
                display: 'block',
                padding: '8px 16px',
                position: 'relative',
                textDecoration: 'none',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                selectors: {
                    ':hover': {
                        color: palette.themePrimary,
                        cursor: 'pointer'
                    }
                }
            },
            className
        ]
    };
};
//# sourceMappingURL=DocumentCardLocation.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardLocation.styles.js
// module id = 948
// module chunks = 0